import { useNavigate } from "react-router-dom";
import { sendPostRequest } from "../../Client";
import { useState } from "react";

const UserRow = ({ item, onDelete, bookingReference }) => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleClick = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await sendPostRequest(`registration/booking/user/add`, {
        bookingReference,
        ballerzUserID: item.ballerzUserID,
      });

      navigate("/pre-registration/finished", {
        state: { bookingReference },
      });
    } catch (e) {
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      onClick={!submitting ? handleClick : undefined}
      aria-disabled={submitting}
      aria-busy={submitting}
      className={[
        "cursor-pointer mx-auto w-full sm:w-1/2 flex flex-col items-center",
        "sm:flex-row sm:items-center sm:justify-between bg-[#1f2644]",
        "rounded-lg p-3 mt-3 text-white font-kallisto gap-3",
        submitting ? "opacity-60 pointer-events-none" : "",
      ].join(" ")}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (!submitting && (e.key === "Enter" || e.key === " ")) handleClick();
      }}
    >
      <div className="w-full sm:w-auto sm:min-w-[30%] bg-[#0d1121] p-2 rounded flex justify-center items-center">
        <span className="text-xl sm:text-2xl font-bold uppercase text-center">
          {item.username}
        </span>
      </div>

      <div className="sm:flex-1 px-2 sm:ml-2 sm:mr-6 text-center sm:text-left">
        <span className="text-xl sm:text-2xl Kallisto_Bold block truncate">
          {item.firstname} {item.lastname}
        </span>
      </div>

      {submitting && (
        <span
          className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-white border-r-transparent"
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default UserRow;
